<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!--차종코드-->
				<el-col :span="3">
					<graph-info-search-kind-car-select-View />
				</el-col>
				<!--판매일자-->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('QWCC000922')">
						<el-date-picker
							v-model="searchDate"
							@change="changeSearchDate"
							type="monthrange"
							align="right"
							start-placeholder="Start Date"
							end-placeholder="End Date"
							range-separator="~"
							format="yyyy-MM"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GraphInfo/store/helpers';
import GraphInfoSearchKindCarSelectView from './GraphInfoSearchKindCarSelectView.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			searchDate: ['', '']
		};
	},
	components: { GraphInfoSearchKindCarSelectView },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		searchList(currentPage = 1, pageUnit = 30) {
			this.$sf_toggleLoading(true);
			this.getCarSalesList_({ currentPage, pageUnit })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchDate(data) {
			const from = this.$moment(data[0]).format('YYYY-MM');
			const to = this.$moment(data[1]).format('YYYY-MM');
			this.searchDate = [from, to];
			this.setSearchParam_({ key: 'startMonth', value: from });
			this.setSearchParam_({ key: 'endMonth', value: to });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'carCdList', codeType: 'TEST_CAR' });
			const tmpGridCarList = [];

			/*그리드 안에 셀렉트박스 넣을 데이터 만들기*/
			this.carCdList.forEach(row => {
				tmpGridCarList.push({
					label: row.commCdName,
					value: row.commCd
				});
			});
			//그리드에 정의한 상태값을 변경시킨다.
			this.setState_({ key: 'gridCarList', value: tmpGridCarList });

			this.searchDate = [this.getStart_, this.getEnd_];

			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
